import React from "react";
import { Box, IconButton, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { UserReport } from "../../RunReports/UserReport/UserReport";
import {
  ReportTemplateBodyParams,
  ReportTemplateTypeEnum,
} from "../../../../services/api/types/reports/reports";
import { AssignmentActivityReport } from "../../RunReports/AssignmentActivityReport/AssignmentActivityReport";
import { UserActivityReport } from "../../RunReports/UserActivityReport/UserActivityReport";

interface PreviewReportModalProps {
  open: boolean;
  onClose: () => void;
  templateData: ReportTemplateBodyParams | null;
  portalId: string | null;
}

export const PreviewReportModal: React.FC<PreviewReportModalProps> = ({
  open,
  onClose,
  templateData,
  portalId,
}) => {
  const isAssignmentReport =
    templateData?.type === ReportTemplateTypeEnum.ASSIGNMENT_ACIVITY_REPORT;
  const isUserActivityReport =
    templateData?.type === ReportTemplateTypeEnum.USER_ACTIVITY_REPORT;

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        overflow: "auto",
        "& .MuiBackdrop-root": {
          backgroundColor: "#2B2B2B",
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: "100%",
          minHeight: "100vh",
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: "fixed",
            top: 24,
            right: 24,
            zIndex: 1000,
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 1)",
            },
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          }}
        >
          <CloseIcon />
        </IconButton>

        {templateData && portalId && (
          <>
            {isAssignmentReport ? (
              <AssignmentActivityReport
                previewTemplateData={templateData}
                previewPortalId={portalId}
                isPreviewMode={true}
              />
            ) : isUserActivityReport ? (
              <UserActivityReport
                previewTemplateData={templateData}
                previewPortalId={portalId}
                isPreviewMode={true}
              />
            ) : (
              <UserReport
                previewTemplateData={templateData}
                previewPortalId={portalId}
                isPreviewMode={true}
              />
            )}
          </>
        )}
      </Box>
    </Modal>
  );
};
